export enum FreeSlotTypeFilter {
  ONLINE = 'online',
  OFFLINE = 'offline',
}

// This is an arbitrary value representing the offline therapy is OFF
export const OFFLINE_NOT_AVAILABLE = 'offline-off'
